import { makeStyles } from '@mui/styles';
import heartLoading from '../../Assets/Svg/Animation - 1746977138850.json';
import Lottie from 'lottie-react';

const useStyles = makeStyles(() => ({
  root: {
    position: 'fixed',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    background: 'rgba(0,0,0,0.3)',
    zIndex: 99999,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
}));

export default function KenLoader() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Lottie animationData={heartLoading} autoPlay loop style={{ width: 150, height: 150 }} />
    </div>
  );
}
